import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import { useTranslation } from "react-i18next";
import LogHistoryContent from "../../components/Pages/LogHistory";

const { displayName } = config;

export default function LogHistory(): React.ReactNode | null {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: Log History`;
  }, []);

  return (
    <Layout title={t("routes.logHistory")}>
      <LogHistoryContent />
    </Layout>
  );
}
